import React, { useState, useEffect } from "react";
import "../styles/cart.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";
import { CustomerProductApi } from "api/customer-product.api";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { getImageUrl } from "utils/helper";
import Loader from "components/loader/loader";
import { TimeUtils } from "utils/time.utils";
import { IoCall } from "react-icons/io5";
import { FaWhatsapp } from "react-icons/fa";

import AnalyticsService from "services/analytics.service";
import {
  BASE_URL,
  CUSTOMER_PRODUCT_POST_TYPE_MAP,
  EVENT_NAME,
} from "utils/constants";
import { LocalStorageUtils } from "utils/localstorage.utils";

const CustomerProductItemPage = () => {
  const { postType, customerProductId } = useParams();
  const [customerProduct, setCustomerProduct] = useState(null);

  useEffect(() => {
    const getCustomerProduct = async () => {
      const customerProductResponse =
        await CustomerProductApi.getCustomerProductById(customerProductId);

      setCustomerProduct(customerProductResponse);
    };
    getCustomerProduct();
  }, [customerProductId]);

  const contactSeller = (mode) => {
    const contactNumber = customerProduct?.customerAddress?.mobile;
    if (mode === "call") {
      window.open(`tel:${contactNumber}`, "_blank");
    } else {
      const message = `Hi,\nमैंने Belivmart पर आपका *"${customerProduct.title}"* का Post देखा। कृपया और जानकारी भेजें।\nPost का लिंक: ${BASE_URL}/customer-products/${customerProduct.postType}/${customerProduct.id}`;
      window.open(
        `https://wa.me/+91${contactNumber}?text=${encodeURIComponent(message)}`,
        "_blank"
      );
    }
    trackContactSeller(mode);
  };

  const trackContactSeller = (mode) => {
    const user = LocalStorageUtils.get(LocalStorageUtils.LOCAL_STORAGE_KEY.USER);
    AnalyticsService.trackEvent(EVENT_NAME.CUSTOMER_PRODUCT_CONTACTED, {
      mode,
      areaId: customerProduct.areaId,
      customerProductId: customerProduct.id,
      postType: customerProduct.postType,
      title: customerProduct.title,
      description: customerProduct.description,
      listingPrice: customerProduct.listingPrice,
      sellingPrice: customerProduct.sellingPrice,
      createdAt: customerProduct.createdAt,
      address: customerProduct.customerAddress?.addressLine1,
      city: customerProduct.customerAddress?.city,
      buyerMobile: user?.mobile,
    });
  };

  return (
    <>
      {!customerProduct ? (
        <div className="loader-container">
          <Loader />
        </div>
      ) : (
        <div className="cart-page">
          <div className="product_popup_cart_image_slider">
            <Swiper
              modules={[Autoplay, Pagination]}
              spaceBetween={10}
              slidesPerView={1}
              pagination={{ clickable: true }}
              autoplay={{ delay: 1000, disableOnInteraction: false }}
              loop={true}
            >
              {[customerProduct.imageUrl].map((image, index) => (
                <SwiperSlide key={index} zoom={true}>
                  <img
                    key={image}
                    src={getImageUrl(image)}
                    alt={customerProduct.title}
                    className="product_popup_cart_slider_image"
                    style={{ height: "100%" }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "0px 10px",
              }}
            >
              <p className="product-price">
                <b style={{ marginRight: "5px", fontSize: "0.8rem" }}>
                  {
                    CUSTOMER_PRODUCT_POST_TYPE_MAP.ADD_PRODUCT_FILED_NAME
                      .SELLING_PRICE[postType]
                  }
                  :
                </b>
                {customerProduct.sellingPrice !== customerProduct.listingPrice && (
                  <span className="original-price">
                    ₹{customerProduct.listingPrice}
                  </span>
                )}

                <span className="final-price">₹{customerProduct.sellingPrice}</span>
              </p>
              <p>{TimeUtils.formatTime(customerProduct.createdAt, "DD MMM")}</p>
            </div>
          </div>

          <div className="product_popup_cart_details">
            <h2 className="product_popup_cart_name">{customerProduct.title}</h2>

            <b>Details:</b>
            <br />
            <p style={{ whiteSpace: "pre-line" }}>{customerProduct.description}</p>
            <br />

            <b>Added By:</b>
            <br />
            <span>Name: {customerProduct.customerAddress.name}</span>
            <br />
            <span>Address: {customerProduct.customerAddress.addressLine1}</span>
            <br />
            <span>City: {customerProduct.customerAddress.city}</span>
            <br />
          </div>

          <div
            style={{
              marginBottom: "120px",
              display: "flex",
              gap: "10px",
              justifyContent: "center",
            }}
          ></div>
          <button
            className="contact-seller-btn"
            style={{ left: "2%", display: "flex", alignItems: "center" }}
            onClick={() => contactSeller("call")}
          >
            <IoCall style={{ marginRight: "3px" }} />
            Call
          </button>
          <button
            className="contact-seller-btn"
            style={{ right: "2%", display: "flex", alignItems: "center" }}
            onClick={() => contactSeller("whatsapp")}
          >
            <FaWhatsapp style={{ marginRight: "3px" }} />
            Whatsapp
          </button>

          <ToastContainer
            id="cart-toast-container"
            style={{ width: "300px" }}
            position="top-center"
            autoClose={3000}
          />
        </div>
      )}
    </>
  );
};

export default CustomerProductItemPage;
